import { bindRequestLogic } from './utils'
import Types from '../actionTypes/groupAlertField'
import { groupAlertFieldAPI } from '../api'

const getGroupAlertFields = bindRequestLogic({
  clientFunc: groupAlertFieldAPI.getGroupAlertFields,
  type: Types.GET_GROUP_ALERT_FIELDS_REQUEST,
  successType: Types.GET_GROUP_ALERT_FIELDS_SUCCESS,
  failType: Types.GET_GROUP_ALERT_FIELDS_FAILED,
  isQueryParam: true
})

const updateGroupAlertField = bindRequestLogic({
  clientFunc: groupAlertFieldAPI.updateGroupAlertField,
  type: Types.UPDATE_GROUP_ALERT_FIELD_REQUEST,
  successType: Types.UPDATE_GROUP_ALERT_FIELD_SUCCESS,
  failType: Types.UPDATE_GROUP_ALERT_FIELD_FAILED
})

export default [getGroupAlertFields, updateGroupAlertField]
